import { Navigate, Outlet } from "react-router-dom"
import { useAtom } from "jotai"
import { userAtom } from "../../state"

/**
 * Route guard for super admin only routes
 * Super admin = is_super_admin flag is true
 */
function SuperAdminRoute() {
  const [user] = useAtom(userAtom)

  if (!user || !user.is_super_admin) {
    return <Navigate to="/admin" replace />
  }

  return <Outlet />
}

export default SuperAdminRoute
